import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from "../components/layout/candidate/Header";
// import Sidebar from "../components/layout/candidate/Sidebar";

const CandidateLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-#222629">
      {/* <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} /> */}
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuToggle={handleMenuToggle} />
        
        <main className="flex-1 overflow-y-auto py-6 px-6 md:px-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default CandidateLayout;